import { useMutation, useQueryClient } from "@tanstack/react-query";
import collectionApiClient, {
  EditApprovedCollectionInput,
} from "../../../api/collection";

const useEditApprovedCollectionMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      collectionId,
      edit,
    }: {
      collectionId: string;
      edit: EditApprovedCollectionInput;
    }) => collectionApiClient.editApprovedCollection(collectionId, edit),
    onSettled: (_data, _error, variables) =>
      Promise.all([
        queryClient.refetchQueries({ queryKey: ["collections"] }),
        queryClient.refetchQueries({
          queryKey: ["collection", variables.collectionId],
        }),
      ]),
  });
};

export default useEditApprovedCollectionMutation;
